import { useRef, useState } from 'react';

export const useMenuControl = <T extends HTMLElement>({
  disabled,
}: { disabled?: boolean } = {}) => {
  const ref = useRef<T | null>(null);
  const [anchor, setAnchor] = useState<T | null>(null);
  const open = Boolean(anchor);

  const handleOpen = () => {
    if (disabled) return;

    setAnchor(ref.current);
  };

  const handleClose = () => {
    setAnchor(null);
  };

  return {
    ref,
    anchor,
    isOpen: open,
    open: handleOpen,
    close: handleClose,
  };
};
